import PageHeader from "../components/PageHeader";
import Reveal from "../components/Reveal";
import { CONTACT } from "../data/site";
import { Mail, Phone, MapPin, Compass } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <PageHeader
        overline="Contact"
        title="Écrire, appeler, "
        italicWord="décoller."
        lead="Notre équipe répond aux demandes tous les jours. Réservations, devis sur mesure ou simple question — nous sommes joignables."
      />
      <section className="py-16 md:py-24 bg-[color:var(--bs-bg)]">
        <div className="mx-auto max-w-[1440px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-5">
            <div className="border-t border-black/15 pt-8 space-y-10">
              <div>
                <div className="overline flex items-center gap-2 text-[color:var(--bs-muted)]">
                  <Mail size={12} strokeWidth={1.5} /> Email
                </div>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="contact-email"
                  className="mt-3 block font-display text-4xl md:text-5xl font-light link-underline"
                >
                  {CONTACT.email}
                </a>
              </div>
              <div>
                <div className="overline flex items-center gap-2 text-[color:var(--bs-muted)]">
                  <Phone size={12} strokeWidth={1.5} /> Téléphone
                </div>
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  data-testid="contact-phone"
                  className="mt-3 block font-display text-4xl md:text-5xl font-light link-underline"
                >
                  {CONTACT.phone}
                </a>
              </div>
              <div>
                <div className="overline flex items-center gap-2 text-[color:var(--bs-muted)]">
                  <Compass size={12} strokeWidth={1.5} /> Base opérationnelle
                </div>
                <div className="mt-3 text-2xl md:text-3xl font-display font-light">
                  {CONTACT.base}
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={0.1}>
            <div className="clip-frame aspect-[4/3] md:aspect-[16/12] w-full overflow-hidden bg-[color:var(--bs-sand)] border border-black/10">
              <iframe
                data-testid="contact-map"
                title="Aérodrome de Namur"
                src="https://www.google.com/maps?q=A%C3%A9rodrome+de+Namur+Temploux&output=embed"
                className="w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
